import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth';
import MapPage from './pages/Map';
import AdminPage from './pages/Admin';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  if (!user) {
    // Should not happen — auth.ts redirects before we get here
    return null;
  }

  return (
    <Routes>
      <Route path="/" element={<MapPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
